<template>
  <form v-on:submit="save">
    <div class="card card-info card-tabs">
      <div class="card-header  p-0 pt-1 pl-1">
        <ul class="nav nav-tabs" id="custom-tabs-four-tab" role="tablist">
          <li class="nav-item">
            <a class="nav-link active" href="#tab_1" data-toggle="pill" role="tab" aria-controls="tab_1" aria-selected="true">Details</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#tab_2" data-toggle="pill" role="tab" aria-controls="tab_2" aria-selected="false">Student Details</a>
          </li>
        </ul>
      </div>
      <div class="card-body">
        <!--v-show="view == 'hide'"-->
        <div class="tab-content active" id="custom-tabs-four-tabContent">
          <div class="tab-pane fade active show" id="tab_1">
            <div class="row">
              <div class="col-md-4">
                <b>Enter Student Roll # *</b>
                <div class="input-group input-group-sm">
                  <input type="text" class="form-control" v-mask="'###########'" v-model="rollno" required autofocus>
                  <span class="input-group-append">
                    <button class="btn btn-info btn-flat" type="button" v-on:click="loadstudents()">Search</button>
                  </span>
                </div>
              </div>
              <div class="col-md-4">
                <b>Active *</b>
                <select class="form-control" v-model="studentactive.CurrentStatus" v-on:change="activeChange()" required>
                  <option selected="selected" disabled="disabled">--Select Status--</option>
                  <option v-bind:value="true">Active</option>
                  <option v-bind:value="false">In-Active</option>
                </select>
              </div>
              <div class="col-md-4" v-if="studentactive.CurrentStatus === false">
                <b>Status *</b> 
                <select class="form-control" v-model="studentactive.Status" required>
                  <option value="" disabled="disabled">--Select Status--</option>
                  <option value="Freez">Freez</option>
                  <option value="Freez">Leave</option>
                  <option value="Drop out">Drop out</option>
                  <option value="Degree Completed">Degree Completed</option>
                </select>
              </div>
              <div class="col-md-6" v-if="studentactive.CurrentStatus === false">
                <b>Remarks *</b> 
                <input class="form-control" v-model="studentactive.Remarks" required />
              </div>
            </div>
          </div>
          <div class="tab-pane fade" id="tab_2">
            <div class="row">
              <div class="col-md-12">
                <div class="table-responsive">
                  <div class="tab-pane" id="tab_2">
                    <table class="table table-bordered table-color">
                      <thead class="bg-info">
                        <tr>
                          <th>Student Name</th>
                          <th>Father Name</th>
                          <th>Roll No</th>
                          <th>Department</th>
                          <th>Program</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{{studentdetail.Name}}</td>
                          <td>{{studentdetail.FathersName}}</td>
                          <td>{{studentdetail.RollNo}}</td>
                          <td>{{studentdetail.DepartmentName}}</td>
                          <td>{{studentdetail.ProgramName}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer">
        <button type="submit" class="btn btn-success float-right" style="width: 120px">Save</button>
        <button class="btn btn-primary" v-on:click="back()" style="width: 120px">Back to List</button>
      </div>
    </div>
  </form>

</template>

<script>
  const axios = require('axios').default;

  export default ({
    data() {
      return {
        studentdetail: [],
        studentactive: {
          CurrentStatus: true,
          Status: "",
          Remarks: "",
        },
        rollno: "",
        state: 'grid',
        view: 'hide',
      }
    },
    

    methods:
    {
      back() {
        window.location.href = "/DC/AllStudentActiveInActive";
      },
      activeChange() {
        this.studentactive.Status = "";
        this.studentactive.Remarks = "";
      },

      changestate: function (newstate) {
        this.state = newstate;
      },

      //checkvalidation() {
      //  if (this.studentactive.CurrentStatus == false) {
      //    if (this.rollno == "") {
      //      toastr.error("Roll Number is Required", "Error!");
      //    }
      //    if (this.studentactive.Status == "") {
      //      toastr.error("Status Is Required", "Error!");
      //    }
      //  }
      //  if (this.studentactive.Remarks == "") {
      //    toastr.error("Remarks Is Required", "Error!");
      //  }
      //  else {
      //    this.savestudentactive();
      //  }
      //},

      loadstudents: function () {
        var vm = this;
        axios.post('/api/DCApi/loadstudentsForStatus?Rollno=' + vm.rollno)
          .then(function (response) {
            if (response.data.lst != null) {
              vm.studentdetail = response.data.lst;
              vm.studentactive.CurrentStatus = vm.studentdetail.Active;
              vm.studentactive.Remarks = vm.studentdetail.Remarks;
              vm.studentactive.Status = vm.studentdetail.Status;
              vm.view = 'show';
            }
            else {
              toastr.error("No Student Found", "Error!");
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      },

      save(e) {
        e.preventDefault();
        var vm = this;
        axios.post('/api/DCApi/savestudentactive?RollNO=' + vm.rollno, {
          obj: vm.studentactive,
        })
          .then(function (response) {
            if (response.data.status) {

              toastr.success("Your data is Saved", "Success");
              vm.studentactive.Remarks= '';
              vm.rollno = '';
              vm.studentactive.CurrentStatus = '';
              //setTimeout(function () { window.location.reload() }, 1000);
              console.log(response);
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      },

    }

  })
</script>





// WEBPACK FOOTER //
// src/components/DC/studentActiveInActive.vue